module.exports={render:function (){var _vm=this;
  return _vm._h('main', {}, [_vm._h('v-parallax', {
    attrs: {
      "src": "/static/back.jpg",
      "height": 300
    }
  }, [_vm._h('v-container', {
    staticClass: "white-text center-align"
  }, [_vm._m(0), " ", _vm._h('h2', [_vm._s(_vm.$t('top.circle_name'))]), " ", _vm._h('v-row', [_vm._h('v-grid', {
    attrs: {
      "s12": ""
    }
  }, [_vm._h('v-btn-link', {
    staticClass: "waves-effect waves-light",
    attrs: {
      "large": true,
      "href": "#modal"
    }
  }, [_vm._s(_vm.$t('top.whats_doujin'))])])])])]), " ", _vm._h('v-container', {
    staticClass: "promo-outer"
  }, [_vm._h('v-row', [_vm._h('v-grid', {
    attrs: {
      "s12": "",
      "m6": ""
    }
  }, [_vm._m(1)]), " ", _vm._h('v-grid', {
    attrs: {
      "s12": "",
      "m6": ""
    }
  }, [_vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('h3', ["Minecraft", _vm._h('br', {
    staticClass: "hide-on-med-and-up"
  }), "同人サークル"])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "promo"
  }, [_vm._h('img', {
    attrs: {
      "src": "/static/svg/webdesign/startup.svg"
    }
  }), " ", _vm._h('p', {
    staticClass: "promo-caption"
  }, ["プレイ人口増加"]), " ", _vm._h('p', {
    staticClass: "promo-info"
  }, ["\n            私たちは、マインクラフトという素晴らしいゲームが大好きです。\n            今日、遊び以外にも学問や研究分野で使用されるなど、幅広く関心を集めています。\n            関心を持つ人たちを、遊びにつなげることができれば、\n            マインクラフトをもっと盛り上げることができます。", _vm._h('br'), "\n            私たちは、マインクラフトを遊ぶ人たちを増やします。\n          "])])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "promo"
  }, [_vm._h('img', {
    attrs: {
      "src": "/static/svg/webdesign/brainstorming.svg"
    }
  }), " ", _vm._h('p', {
    staticClass: "promo-caption"
  }, ["ファンが集う場所"]), " ", _vm._h('p', {
    staticClass: "promo-info"
  }, ["\n            マインクラフトの情報源やコミュニティは、インターネット上に散在しています。\n            もっとマインクラフトを盛り上げるためには、幅広く情報がまとめられている\n            場所が必要です。そして、日本中のマインクラフトファンが楽しめる場所を提供する\n            ことはとても重要です。", _vm._h('br'), "\n            私たちは、良質な情報とコミュニティを提供します。\n          "])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ead2e74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Top.vue
// module id = 55
// module chunks = 2